// import execInstallGlobalModules from './install-global-modules'
// import execAxios from './axios'
import execVueSizeTracker from './vue-size-tracker-plugin';
import execFilters from './filters';
// import execI18n from './i18n'
import execBus from './bus';
import raven from './raven';
import vueDayjs from './vue-dayjs';
export default function () {
  //   execInstallGlobalModules()
  //   execAxios()
  execVueSizeTracker();
  execFilters();
  //   execI18n()
  execBus();
  raven();
  vueDayjs();
}
